import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { TARGETS } from './constants';

const initialStateDescription = {
  onInitialLoad: true,
  [TARGETS.SIGN_IN_WITH_EMAIL_AND_PASSWORD]: null
};

const initialState = completeState(initialStateDescription);

const reducerDescription = {
  primaryActions: [actions.SIGN_IN_WITH_EMAIL_AND_PASSWORD],
  override: {
    [actions.SET_VALUE]: onReadValue()
  }
};

const reducer = createReducer(new Immutable(initialState), completeReducer(reducerDescription));

export default reducer;
